module.exports = __webpack_public_path__ + "img/v1-analyst.4307caf0.png";